import { PageType } from "shared/lib/page-type";

export const pathname = "/plus/search";

export const page = {
  route(this: void, query: QueryParameters<{ nodeId?: string; q?: string }>) {
    return {
      asPath: `${pathname}${query.q ? `?q=${encodeURIComponent(query.q)}` : ""}`,
      pathname,
      query: { ...query, pageType: PageType.Plus },
    };
  },
};
